import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=74e99b5d&fddApi"
import script from "./notify.vue?vue&type=script&lang=js&fddApi"
export * from "./notify.vue?vue&type=script&lang=js&fddApi"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports